module.exports = "<app-navbar></app-navbar>\n<p-tabMenu [model]=\"items\"></p-tabMenu>\n<router-outlet></router-outlet>"